const en = ['CASH_BEFORE', 'CASH_AFTER', 'CHEQUE', 'CREDIT_7', 'CREDIT_14', 'CREDIT_30', 'CREDIT_45', 'CREDIT_60'];
const th = ['เงินสด (ต้นทาง)', 'เงินสด (ปลายทาง)', 'เช็ค', 'เครดิต 7 วัน', 'เครดิต 14 วัน', 'เครดิต 30 วัน', 'เครดิต 45 วัน', 'เครดิต 60 วัน'];

function translate(string: string) {
  if (string === 'CASH') return 'เงินสด';
  const index = en.indexOf(string);
  if (index > -1) return th[index];
  return '';
}

export default function usePayment() {
  return {
    en,
    th,
    translate,
  };
}
